import type { MaskPoint } from '../game/types';

export interface RectangleLike {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function toMaskPoint(
  screenX: number,
  screenY: number,
  bounds: RectangleLike,
  maskWidth: number,
  maskHeight: number,
): MaskPoint | null {
  if (bounds.width <= 0 || bounds.height <= 0 || maskWidth <= 0 || maskHeight <= 0) {
    return null;
  }

  const normalizedX = (screenX - bounds.left) / bounds.width;
  const normalizedY = (screenY - bounds.top) / bounds.height;
  if (normalizedX < 0 || normalizedX > 1 || normalizedY < 0 || normalizedY > 1) {
    return null;
  }

  return {
    x: Math.min(maskWidth - 1, Math.max(0, Math.floor(normalizedX * maskWidth))),
    y: Math.min(maskHeight - 1, Math.max(0, Math.floor(normalizedY * maskHeight))),
  };
}
